import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
//import { strings } from '../../resources/strings'; //adjust the path if necessary

export class TicketInfo extends Component {
    render() {
        return (
            <Container fluid className="mb-5 tariff">
                <Row className="mt-5" style={{ backgroundColor: '#e9ecef' }}>
                    <p className="ticket-info-title" >
                        <strong>títulos de transporte</strong> <span>condições</span>
                    </p>
                    <a href="docs/Tarifas_AVE MOBILIDADE.pdf" target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.8rem' }}>
                        Descarregar Informação Tarifária Completa
                    </a>
                </Row>
                <Row style={{ marginTop: "2rem" }}>
                    <p className="ticket-info-attention">
                        <span>APOIOS À MOBILIDADE</span> <strong>CIM DO AVE</strong>
                    </p>
                    <a href="docs/Apoio mobilidade_DIGITAL.pdf" target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.8rem' }}>
                        Conheça os subsídios disponíveis e as respetivas condições de acesso
                    </a>
                </Row>
                <Row>
                    <Col md={6}>
                        <Row className="mt-5">
                            <h5 className="purple">
                                {/*<img*/}
                                {/*    src="placeholder_ticket_icon.png" */}
                                {/*    alt="Ticket Icon"*/}
                                {/*    className="ticket-type-icon"*/}
                                {/*/>*/}
                                BILHETE <b>SIMPLES A BORDO</b><br />
                                INTEIRO E MEIO
                            </h5>
                            <ul>
                                <li>Título <b>não personalizado</b>;</li>
                                <li>Vendido a bordo;</li>
                                <li>Permite a realização de 1 viagem no autocarro onde foi adquirido;</li>
                            </ul>
                        </Row>
                        <Row className="mt-5">
                            <h5 className="green">
                                {/*<img*/}
                                {/*    src="placeholder_ticket_icon.png"  */}
                                {/*    alt="Ticket Icon"*/}
                                {/*    className="ticket-type-icon"*/}
                                {/*/>*/}
                                BILHETE <b>SIMPLES</b><br />
                                CARTÃO VALOR
                            </h5>
                            <ul>
                                <li>Titulo <strong>não personalizado</strong>;</li>
                                <li>Vendido e recarregado na bilheteira;</li>
                                <li>Tem de ser validado em cada viagem efetuada;</li>
                                <li>Permite a realização de viagens em qualquer linha e Origem / Destino da rede.</li>
                            </ul>
                        </Row>
                        <Row className="mt-5">
                            <h5 className="red">
                                {/*<img*/}
                                {/*    src="placeholder_ticket_icon.png"  */}
                                {/*    alt="Ticket Icon"*/}
                                {/*    className="ticket-type-icon"*/}
                                {/*/>*/}
                                <b>PRÉ-COMPRADO</b><br />
                                10 VIAGENS (PC10)
                            </h5>
                            <ul>
                                <li>Título <strong>não personalizado</strong>;</li>
                                <li>Vendido e recarregado na bilheteira.</li>
                                <li>Tem de ser validado em cada viagem efetuada;</li>
                                <li>Permite a realização de 10 viagens na Origem / Destino escolhidos.</li>
                            </ul>
                        </Row>
                        <Row className="mt-5">
                            <h5 className="darkgreen">
                                {/*<img*/}
                                {/*    src="placeholder_pass_icon.png"  */}
                                {/*    alt="Pass Icon"*/}
                                {/*    className="ticket-type-icon"*/}
                                {/*/>*/}
                                PASSE <b>MENSAL</b>
                            </h5>
                            <ul>
                                <li>Título <strong>personalizado, pessoal e intransmissível</strong>;</li>
                                <li>Vendido na bilheteira;</li>
                                <li>Recarregado mensalmente na bilheteira ou na rede SaltPay;</li>
                                <li>Válido para o mês e Origem / Destino para o qual foi adquirido com número de viagens ilimitadas;</li>
                                <li>Tem de ser validado a bordo do autocarro.</li>
                            </ul>
                        </Row>
                    </Col>
                    <Col md={6}>
                        <Row className="mt-5">
                            <h5 className="yellow">
                                {/*<img*/}
                                {/*    src="placeholder_pass_icon.png"  */}
                                {/*    alt="Pass Icon"*/}
                                {/*    className="ticket-type-icon"*/}
                                {/*/>*/}
                                PASSE <b>SÉNIOR</b>
                            </h5>
                            <ul>
                                <li>Destinado a <strong>pessoas com mais de 65 anos</strong> e que possuam Cartão Municipal do Idoso ou documento equivalente;</li>
                                <li>Permite viajar na Origem / Destino escolhidos.</li>
                            </ul>
                        </Row>
                        <Row className="mt-5">
                            <h5 className="blue">
                                {/*<img*/}
                                {/*    src="placeholder_pass_icon.png"  */}
                                {/*    alt="Pass Icon"*/}
                                {/*    className="ticket-type-icon"*/}
                                {/*/>*/}
                                PASSE <b>GRATUITO PARA JOVENS</b>
                            </h5>
                            <ul>
                                <li>Título <strong>personalizado, pessoal e intransmissível</strong>;</li>
                                <li>Vendido na bilheteira;</li>
                                <li>Recarregado mensalmente a bordo;</li>
                                <li>Válido todos os dias do mês para o qual foi adquirido com um número ilimitado de viagens;</li>
                                <li>Permite viajar na Origem / Destino escolhidos;</li>
                                <li>Tem de ser sempre validado a bordo do autocarro;</li>
                                <li>Destina-se a jovens entre os 4 e os 23 anos (inclusive);</li>
                                <li>Renovável até ao último dia do mês antes de completar os 24 anos;</li>
                            </ul>
                        </Row>
                        <Row className="mt-5">
                            <h5 className="darkgray">
                                {/*<img*/}
                                {/*    src="placeholder_pass_icon.png"  */}
                                {/*    alt="Pass Icon"*/}
                                {/*    className="ticket-type-icon"*/}
                                {/*/>*/}
                                PASSE <b>PESSOAS COM MOBILIDADE CONDICIONADA</b><br />
                                (PPMC)
                            </h5>
                            <h5 className="darkgray">
                                PASSAGEIROS
                            </h5>
                            <ul>
                                <li>Destina-se a pessoas com grau de incapacidade igual ou superior a 60% e que possuem o Cartão Municipal de Pessoa com Deficiência. Funciona nos mesmos moldes do Passe Mensal (PM), mas com desconto de 50% sobre a tarifa aplicável.</li>
                            </ul>
                            <h5 className="darkgray">
                                ACOMPANHANTE
                            </h5>
                            <ul>
                                <li>Destina-se a acompanhantes de pessoas com mobilidade condicionada, com um grau de incapacidade igual ou superior a 80%. Sem custos associados.</li>
                            </ul>
                        </Row>
                    </Col>
                </Row>
            </Container>
        );
    }
}
